import { ThemeStorageContext as e, DarkModeContext as r } from "@karrotmarket/react-theming";
export { DarkModeContext, ThemeStorageContext } from "@karrotmarket/react-theming";
import * as t from "react";
import o from "use-dark-mode";
import { Global as a, css as n, ThemeProvider as i } from "@emotion/react";
import { populateSemanticColors as m, colors as c } from "@karrotmarket/design-token";
import { jsxs as s, Fragment as h, jsx as l } from "react/jsx-runtime";

function d() {
  return (d = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var u,
    k = function k(e, r) {
  switch (e) {
    case "auto":
      return r ? "dark" : "light";

    case "light-only":
      return "light";

    case "dark-only":
      return "dark";
  }
},
    g = function g(_g) {
  var v,
      p,
      f = _g.children,
      y = _g.mode,
      x = void 0 === y ? "auto" : y,
      N = t.useContext(e),
      C = o("dark-only" === x, {
    storageProvider: N,
    classNameDark: "dark-theme",
    classNameLight: "light-theme",
    onChange: function onChange(e) {
      void 0 === e && (e = !1);
      var r = "dark" === k(x, e) ? ["dark-theme", "light-theme"] : ["light-theme", "dark-theme"],
          t = r[1],
          o = document.body;
      o.classList.add(r[0]), o.classList.remove(t);
    }
  }),
      O = t.useMemo(function () {
    var e = c[k(x, C.value)];
    return {
      colors: d({}, e.scheme, m(e.scheme, e.semanticScheme))
    };
  }, [x, C.value]);
  return s(h, {
    children: [l(a, {
      styles: n(u || (v = ["\n          :root {\n            color-scheme: ", ";\n          }\n        "], p || (p = v.slice(0)), v.raw = p, u = v), {
        auto: "light dark",
        "light-only": "light",
        "dark-only": "dark"
      }[x])
    }), l(r.Provider, {
      value: C,
      children: l(i, {
        theme: O,
        children: f
      })
    })]
  });
};

"production" !== process.env.NODE_ENV && (g.displayName = "KarrotThemeProvider(Emotion)");
export { g as KarrotThemeProvider };